/**
 * This middleware only has an effect in Node.js.
 */
export function agent(opts?: any): any {
  return {}
}
